<template>
  <div>
    <v-form v-model="valid" ref="docHabilitacaoJuridicaForm">
      <v-flex p-b-30 v-for="doc in listaDocFornecSolicitacao.filter(documento =>
        documento.numHabilitacao === '2'
        &&   documento.codDocumento != 32
        && ((model.finalidadeEmpresa == 0 && documento.indSemFinsLucrativos != '1')
          || (model.finalidadeEmpresa == 1 && documento.indSemFinsLucrativos != '1' && model.flagSociedadeAnonima == 1)
          || (model.finalidadeEmpresa == 1 && documento.indComFinsLucrativos != '1' && model.flagSociedadeAnonima == 0)))"
          :key="doc.codDocumento">
        <div class="p-t-20 p-b-20">
          <div class="tituloBox border-top">
            <div class="bg-red barraTitulo"></div>
            <h1 class="text-default font-size-14">
              <strong>{{doc.nomDocumento.toUpperCase()}}</strong>
              <popper v-if="model.flagEstrangeiro === '1'" :stop-propagation="true" :options="{placement: 'right'}">
                <div class="popper">
                  Ou documento equivalente conforme Lei nº 9.433/2005
                </div>
                <button prevent-default="true" type="button" class="san" slot="reference">
                  <v-icon        
                    class="mx-1 san"
                    slot="activator"
                    :size="25"
                    color="primary"
                    style="margin-top:-6px"
                    
                  >info</v-icon>
                </button>
              </popper>
            <popper v-if="doc.codDocumento === 146 || doc.codDocumento === 32 " :stop-propagation="true" :options="{placement: 'right'}">
              <div class="popper">
                Contrato Social e Ultima Alteração (se houver)
              </div>
              <button prevent-default="true" type="button" class="san" slot="reference">
                  <v-icon        
                    class="mx-1 san"
                    slot="activator"
                    :size="25"
                    color="primary"
                    style="margin-top:-6px"
                  >info</v-icon>
              </button>
            </popper>

            </h1>
          </div>
        </div>
        <div class="clear"></div>
        <v-card>
          <v-layout row wrap>
            <v-flex xs4>
              <datePicker
                v-model="doc.docSolicitacao.datExpedicao"
                :dataDefault="doc.docSolicitacao.datExpedicao"
                v-mask="maskData"
                :limitarData="true"
                :rules="[v=>validaIfObrigatorio(v,doc)  || $t('messages.validacao.campoObrigatorio')]"
                :label="'Data do '+  titleCase(doc.nomDocumento)  + testeAsterico(doc)"
                :required="doc.indSemFinsLucrativos == '3' || doc.indComFinsLucrativos == '3'  || (doc.Documento === 'ATA'  && model.finalidadeEmpresa === 0 )"
                validate-on-blur
                :hint="ifDataDocumentoAlterado(doc.docSolicitacao.datExpedicao,'datExpedicao',doc.codDocumento)"
                persistent-hint
                @change="alteracaoValorCampo(doc.docSolicitacao)"
              />
            </v-flex>

            <v-flex inputIcon xs8 v-show="doc.docSolicitacao.arquivoUpload != null">
              <TextFieldValidadorDelete
                :arquivoUpload="doc.docSolicitacao.arquivoUpload"
                :arquivoUploadSituacao="doc.docSolicitacao.arquivoUploadSituacao"
                :idMotivoIndeferimentoArquivo="doc.docSolicitacao.idMotivoIndeferimentoArquivo"
                :codDocumento="''+doc.docSolicitacao.codDocumento"
                :idFornecedor="model.numCgcFornecedor"
                v-on:clear="iconDelete(doc)"                
                v-on:aprovar="validarCampo(doc,2)"
                v-on:rejeitar="validarCampo(doc,1,$event)"
                :label="'Anexo do(a) '+ titleCase(doc.nomDocumento) + testeAsterico(doc)"
                :clearable="true"
                :rules="[isAnexoValido(doc) || $t('messages.validacao.documentoInvalido')]"
                :hint="ifValueDocumentoAlterado(doc.docSolicitacao.arquivoUpload,'arquivoUpload', doc.codDocumento)"
                persistent-hint
              ></TextFieldValidadorDelete>

              <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
                <v-card>
                  <v-card-title class="headline">Atenção!</v-card-title>
                  <v-form>
                    <v-layout row wrap>
                      <v-flex xs12><br />
                        Deseja excluir o documento?
                      </v-flex>
                    </v-layout><br /><br />
                    <v-layout wrap p-b-10>
                      <v-flex xs12 sm6>
                        <v-btn @click="cancelarDialog()">Não</v-btn>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn color="info" @click="apagarItem(doc)" :loading="isLoading">Sim</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>

            <v-flex xs8 v-if="doc.docSolicitacao.arquivoUpload == null">
              <uploadFile
                tamanhoMaximo="30MB"
                :required="doc.indSemFinsLucrativos == '3' || doc.indComFinsLucrativos == '3' || (doc.nomDocumento === 'ATA' && model.finalidadeEmpresa === 0)"
                :label="'Anexar '+ titleCase(doc.nomDocumento) + testeAsterico(doc)"
                v-model="doc.file"
                accept=".pdf, .PDF"
              />
            </v-flex>  
          </v-layout>
        </v-card>
      </v-flex>
    </v-form>
    <v-layout row wrap class="p-t-10">
        <v-flex sm2 v-if="model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 0 || model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 1">
          <v-btn
            slot="activator"
            color="primary"
            class="mb-2"
            @click="fnCrud('S')"
          >Incluir Sócio</v-btn>
        </v-flex>
        <v-flex sm2 Slass="left" v-if="model.finalidadeEmpresa == 0 || model.finalidadeEmpresa == 1 && model.flagSociedadeAnonima == 1">
          <v-btn
            slot="activator"
            color="primary"
            class="mb-2"
            @click="fnCrud('D')"
          >Incluir Dirigente</v-btn>
        </v-flex>
        <!-- <v-flex class="left p-l-10" style="color:red;" v-if="sociedade_completa">
          <h3 style="font-size:bold">Empresa com quadro societário completo </h3>
        </v-flex> -->
    </v-layout>
    <dirigentesSociosCrud
      :model="model"
      :modelEdit="modelEdit"
      :habilitacaoLista="habilitacaoLista"
      :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
      :crud="crud"
      v-if="crud.show"
    />

    <dirigentesTable 
      v-on:editarItem="fnEdit($event)"
      :model="model"
      :OldModel="OldModel"
      :habilitacaoLista="habilitacaoLista"
      :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
    />
 
    <sociosTable
      v-on:editarItem="fnEdit($event)"
      :model="model"
      :OldModel="OldModel"
      :habilitacaoLista="habilitacaoLista"
      :erroHabilitacaoJuridica="erroHabilitacaoJuridica"
    />
  </div>
</template>

<script>
import dirigentesTable from "./components/dirigentes-table";
import sociosTable from "./components/socios-table";
import dirigentesSociosCrud from "./components/dirigentesSocios-crud";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import analiseCampoAlterado from "./components/analiseCampoAlterado";
import TextFieldValidadorDelete from "../../../components/text-field-validador-delete.vue";
export default {
  name: "hablitacao-juridica",
  mixins: [util,analiseCampoAlterado],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    erroHabilitacaoJuridica: Object,
    upload: Object,
    OldModel: Object,
    listaDocFornecSolicitacao:Array,
    hasErroDocHabilitacao: Boolean  
  },
  components: {
    dirigentesTable,
    sociosTable,
    dirigentesSociosCrud,
    TextFieldValidadorDelete
},
  watch: {
    model(newV, oldV) {
      if (newV != oldV) {
        this.limpaArquivoUploadAlteracao();
      }
    }
  },
  created() /*Metodo de start do componente*/{
  },
  computed: {
      habilitacaoLista() {
        if (!this.model.fornecedoresHabilitacaoJuridica) {
          return {
            sociosLista: [],
            dirigentesLista: []
          };
        }
        
        const dirigentesLista = [];
        const sociosLista = [];
        
        this.model.fornecedoresHabilitacaoJuridica.forEach(item => {
          if (item.tipoCadastro === "D") {
            dirigentesLista.push(item);
          } else {
            sociosLista.push(item);
          }
        });
        
        return {
          dirigentesLista,
          sociosLista
        };
      }
    },
  mounted(){
    if(this.hasErroDocHabilitacao){
      this.$refs.docHabilitacaoJuridicaForm.validate();
    }
  },
  data() {//Declaracao de variaveis
    return {
      // sociedade_completa: false,
      dialog: false,
      novoAnexoContratoSocial: false,
      crud: {
        tipoCadastro: null,
        show: false,
        acao: "incluir"
      },
      
      valid: false,
      modelEdit: {},
      loadedHabilitacao: false
    };
  },

  methods: {//Declaracao de todos os metodos

    iconDelete(doc) {
      this.dialog = true;      
    },

    cancelarDialog() {
      this.dialog = false;
    },

    apagarItem(doc) {
      doc.docSolicitacao.arquivoUpload = null;
      doc.file = null;
      this.dialog = false;
    },

    // atualizar_mesagem(){
    //   this.sociedade_completa = false;
    // },
    fnEdit(modelEdit) {
      // this.sociedade_completa = false,
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.modelEdit = Object.assign({}, modelEdit);
      this.crud.show = false;
      setTimeout(() => {
        this.crud.tipoCadastro = this.modelEdit.tipoCadastro;
        this.crud.acao = "edit";
        this.crud.show = true;
        this.$removePreload(); /*Ocultar o PreLoad*/
      }, 200);
      document.scrollingElement.scrollTop = 0;
    },
     validaIfObrigatorio(v, validar) {
       //validar se o documento é obrigatorio
       if(validar){
        // validar.indSemFinsLucrativos e validar.indComFinsLucrativos são do tipo number
        if (validar.indSemFinsLucrativos === 3 || validar.indComFinsLucrativos === 3
        ) {
          return !!v;
        }else if ((validar.nomDocumento === 'ATA') && (this.model.finalidadeEmpresa === 0)){
           return !!v;
        }else {
          return true;
        }
       }else{
         return true;
       }
    },
     testeAsterico(validar){
      //testar se o documento é obrigatorio
      if(validar){
        // validar.indSemFinsLucrativos e validar.indComFinsLucrativos são do tipo number
        if (validar.indSemFinsLucrativos === 3 || validar.indComFinsLucrativos === 3
        ) {
          return " *";
        }else if((validar.nomDocumento === 'ATA') && (this.model.finalidadeEmpresa === 0)) {
          return " *";
        }else {
          return "";
        }
       }else{
         return "";
       }
    },
    fnCrud(tipoCadastro) {
      let percentualTotal = 0;
      if(this.habilitacaoLista.sociosLista){
        this.habilitacaoLista.sociosLista.forEach(item => {
          percentualTotal += parseFloat( String(item.percentual).replace(",","."));
        });

      }
      // if(percentualTotal >= 100.0){
      //   this.sociedade_completa = true;
      //   return;
      // }else{
      //   this.sociedade_completa = false;
      // }

      setTimeout(() => {
        this.crud.tipoCadastro = tipoCadastro;
        this.crud.show = true;
        document.scrollingElement.scrollTop = 0;
      }, 200);
    },
    listarFornecedorHabilitacaoJuridica() {
      //listar os socios/dirigentes
      console.log(this.model.fornecedoresHabilitacaoJuridica);
      this.model.fornecedoresHabilitacaoJuridica.filter(item => {
        if (item.tipoCadastro === "D") {
          this.habilitacaoLista.dirigentesLista.push(item);
        } else {
          this.habilitacaoLista.sociosLista.push(item);
        }
      });
      this.loadedHabilitacao = true;
    },
    baixarArquivo(arquivo) {
      //baixar o arquivo
      const numCgcFornecedor = this.$verificaPerfilHabilitador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g,"")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },
    titleCase(str) {
      //metodo para formatar a string
      //colocar as letras inicias maiusculas
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    validarCampo(doc, situacao, motivo) {
      //metodo para aprovar ou rejeitar o documento
      const model = {
        IdDocumentosSolicitacao: doc.docSolicitacao.idDocumentosSolicitacao,
        arquivoUploadSituacao: situacao,
        IdMotivoIndeferimentoArquivo: motivo
      };
      fornecedorService.aprovarRejeitarArquivoUpload(model).then(response => { /*resposta do servico*/
        doc.docSolicitacao.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
        doc.docSolicitacao.idMotivoIndeferimentoArquivo = response.data.idMotivoIndeferimentoArquivo;
        doc.docSolicitacao.dtArquivoUploadRejeicao = response.data.dtArquivoUploadRejeicao;
        if (situacao === 1) {
          this.$toasted.success(
            this.$t("messages.cadastro.rejeitadoComSucesso")
          );
        } else {
          this.$toasted.success(
            this.$t("messages.cadastro.aprovadoComSucesso")
          );
        }
      });
    },
    limpaArquivoUploadAlteracao()
    {
      //Forçar o habilitador a anexar o arquivo quando o mesmo for "Não Encontrado"
      if (this.model.arquivoUpload === "Não Encontrado")
      {
        this.model.arquivoUpload = null;
        this.upload.novoAnexoContratoSocial = true;
      }
      this.model.fornecedoresHabilitacaoJuridica.filter(item => {
        if (item.arquivoUpload === "Não Encontrado" ) {
          item.arquivoUpload = null;
        }
      });
    },

    alteracaoValorCampo(docSolicitacao){
      //Remove validacao de documento caso um campo seja alterado
      docSolicitacao.arquivoUploadSituacao  = null;
      docSolicitacao.idMotivoIndeferimentoArquivo = null;
      docSolicitacao.dtArquivoUploadRejeicao = null;
    },

     isAnexoValido(doc){
      return (doc.file != null || (!!doc.docSolicitacao['arquivoUpload'] && doc.docSolicitacao['arquivoUpload'] !== "Não Encontrado"));
    }
  }
};
</script>


<style>
.btn.focus, .btn:focus, .san {
    outline: 0;
    box-shadow: none!important;
    border: none;
}

.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
  border-radius: 0;
  border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}
</style>
